import { create } from 'zustand'

/**
 * KnowNow has a single design system (cream paper + crimson ink).
 * The only user-facing surface is the light/dark mode toggle.
 */
export type Theme = 'light' | 'dark'

export interface ThemeOption {
  readonly value: Theme
  readonly label: string
  readonly description: string
}

export const THEMES: readonly ThemeOption[] = [
  {
    value: 'light',
    label: 'Light',
    description: 'Cream paper with crimson ink',
  },
  {
    value: 'dark',
    label: 'Dark',
    description: 'Warm charcoal with cream ink',
  },
] as const

export const DEFAULT_THEME: Theme = 'light'
export const THEME_STORAGE_KEY = 'knownow:theme'

export function isTheme(value: unknown): value is Theme {
  return typeof value === 'string' && THEMES.some((t) => t.value === value)
}

export interface ThemeState {
  readonly theme: Theme
  setTheme: (theme: Theme) => void
}

export const useThemeStore = create<ThemeState>((set) => ({
  theme: DEFAULT_THEME,
  setTheme: (theme: Theme): void => set({ theme }),
}))
